<script>
import {
    HorizontalBar
} from 'vue-chartjs'

export default {
    extends: HorizontalBar,
    props: ['ORDEM', 'G'],
    mounted() {
        this.renderChart({
            labels: this.ORDEM,
            datasets: [
                {
                    label: 'Gastos',
                    backgroundColor: 'rgb(108, 187, 241, 0.5)',
                    borderColor: 'rgb(108, 187, 241, 1)',
                    borderWidth: 1,
                    data: this.G
                }
            ]
        }, {
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: true,
                text: 'Ranking - Gastos',
                fontSize: 14
            },
            scales: {
                xAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Valores em €'
                    },
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/Chart5.vue